import { combineEpics } from 'redux-observable';
import { closeMarkupBeforeRemoveEpic } from './_epics/closeMarkupBeforeRemove.epic';
import { reloadMarkupListEpic } from './_epics/reloadMarkupList.epic';
import { toggleViewMarkupSidebarEpic } from './_epics/toggleViewMarkupSidebar.epic';
import { closeBulkEditSidebarOnDoneEpic } from './_epics/closeBulkEditSidebarOnDone.epic';

export const controllerMarkupEpic = combineEpics(
  closeMarkupBeforeRemoveEpic,
  reloadMarkupListEpic,
  toggleViewMarkupSidebarEpic,
  closeBulkEditSidebarOnDoneEpic,
);
